<mat-card>
  <mat-card-title>Server Side Lookup Options</mat-card-title>
  <mat-card-content>
    <div>
      <mat-checkbox [(ngModel)]="failValidationOnFailedLookup" (change)="setFailValidationOnFailedLookup()">Fail validation on failed lookup</mat-checkbox>
    </div>
    <div>
      <mat-checkbox [(ngModel)]="publishAnywayOnFailedLookup" (change)="setPublishAnywayOnFailedLookup()">Save and publish anyway on failed lookup</mat-checkbox>
    </div>
    <div>
      <mat-checkbox [(ngModel)]="allowMappingAfterFirstSave" (change)="setAllowMappingAfterFirstSave()">Allow mapping after first save</mat-checkbox>
    </div>
  </mat-card-content>
</mat-card>